//useProTableOt
import React, { useEffect, useState } from "react";
import { ArrowDownAZ, ArrowDownZA } from "lucide-react";
import { Checkbox } from "../../../ui/checkbox";
import { MainModal, Form, Button, Popconfirm, Card, Row, Col, DeletePopHover, Typography, Spin } from "../../../ui/ot";
import { RadioGroup, RadioGroupItem } from "../../../ui/radio-group";
import { useTranslation } from "react-i18next";


const useProTableOt = ({
    columns,
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {

    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: "DESC",
                    });
                } else {
                    return JSON.stringify({
                        column: key,
                        type: "ASC",
                    });
                }
            });

            return newOrders;
        } else {
            return [];
        }
    };
    function isArrowFunctionEmptyBlock(func) {
        // 檢查是否是函數類型
        if (typeof func !== 'function') {
            return false;
        }

        // 將函數轉為字串，並檢查其字串內容
        const funcString = func.toString().replace(/\s+/g, '');

        // 判斷是否符合箭頭函數的空定義樣式 "()=>{}"
        return funcString === '()=>{}';
    }
    const transferColumnAntdToShadcn = ({
        columns = [],
        currentTableData = [],
        selectedRowKeys = [],
        setSelectedRowKeys = () => { },
        selectedRowsInfo,
        setSelectedRowsInfo = () => { },
        rowSelectType,
        actionColumns = [1],
        rowKey,
        onChange = () => { },
        onSelect = () => { },
        onSelectAll = () => { },
        propsPatchOnBefore = () => { },
        propsPatchonFinish = () => { },
        PropsPatchForm = () => <></>,
        propsOnModalConfirm,
        propsUseData = () => { },
        propsPatch = false,
        propsPatchProcess,
        propsPostOnBefore,
        propsPostChildren,
        propsPostChildrenKey,
        modalOpen = modalOpen,
        setModalOpen = setModalOpen,
        propsForm,
        propsDelete = false,
        axiosMode,
        setAxiosMode = () => { },
        extraActionRender = () => { },
        propsDeleteModal = false,
        propsChildrenText,
        initialValues,
        readonly = false,
        extraActionRenderShow = true
    }) => {
        let transferColumns = [];
        transferColumns = (columns || []).map((tableColumn, columnIndex) => {

            return {
                ...tableColumn,
                id: tableColumn?.key,
                key: tableColumn?.key,
                disabled: tableColumn?.disabled,
                accessorKey: tableColumn?.dataIndex,
                enableSorting: tableColumn?.sorter,
                enablePinning: !!tableColumn?.fixed,
                // pinningPosition: !!tableColumn?.fixed && 'left',
                header: ({ header, table, column }) => {
                    if (typeof tableColumn?.title === "string") {
                        return (
                            <div
                                style={{
                                    width: tableColumn?.width
                                        ? tableColumn?.width
                                        : "100%",
                                    whiteSpace: !!tableColumn?.width ? 'inherit' : "nowrap",
                                    // whiteSpace:'',
                                    display: "flex",
                                    textAlign: tableColumn?.align || "center",
                                    justifyContent: tableColumn?.align || "center",
                                    alignItems: tableColumn?.align || "center",
                                }}
                                onClick={() => {
                                    if (column.getCanSort()) {
                                        column.toggleSorting()
                                    }

                                }}
                            >
                                <Row align={"middle"} justify={tableColumn?.align || "center"} wrap={false}>
                                    <Col>
                                        {tableColumn?.title}
                                    </Col>
                                    <Col>
                                        {column.getIsSorted().toString() === "asc" && (
                                            <ArrowDownAZ className="ml-2 h-4 w-4" />
                                        )}
                                        {column.getIsSorted().toString() === "desc" && (
                                            <ArrowDownZA className="ml-2 h-4 w-4" />
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        );
                    } else {
                        return (
                            <div
                                style={{
                                    textAlign: tableColumn?.align || "center",
                                    display: "flex",
                                    justifyContent: tableColumn?.align || "center",
                                    alignItems: tableColumn?.align || "center",
                                }}
                            >
                                {tableColumn?.title}
                            </div>
                        );
                    }
                },
                cell: ({ table, row, column, cell, getValue }) => {
                    let text = row?.original;
                    if (tableColumn?.dataIndex) {
                        text = row?.original[tableColumn?.dataIndex];
                    }
                    let record = row?.original;
                    let index = row?.index;
                    if (typeof tableColumn.render === "function") {
                        return (
                            <div
                                style={{
                                    textAlign: tableColumn?.align || "start",
                                    justifyContent:
                                        tableColumn?.align || "start",
                                    display: "flex",
                                    alignItems: tableColumn?.align || "center",
                                    paddingLeft: `${row.depth * 20}px`, // 動態縮排
                                    paddingRight: "0.5rem", // 動態縮排
                                    position: "relative",
                                    transition: "background-color 0.3s", // 平滑過渡效果
                                }}
                            >
                                {columnIndex === 0 && (
                                    <>
                                        {row.getCanExpand() && (
                                            <>
                                                <button
                                                    {...{
                                                        onClick:
                                                            row.getToggleExpandedHandler(),
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: tableColumn?.align || "center",
                                                            justifyContent: "center",
                                                            width: "24px",
                                                            height: "24px",
                                                            backgroundColor: "#007bff",
                                                            color: "white",
                                                            border: "none",
                                                            borderRadius: "50%",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                            transition: "background-color 0.3s",
                                                            marginRight: "8px", // 按鈕與文字的間距
                                                        },
                                                    }}
                                                >
                                                    {row.getIsExpanded()
                                                        ? "−"
                                                        : "＋"}
                                                </button>
                                            </>
                                        )}
                                    </>
                                )}
                                <div style={{
                                    flex: 1,
                                    textAlign: tableColumn?.align,
                                    justifyContent: tableColumn?.align,
                                }}>

                                    {tableColumn.render(text, record, index) ||
                                        text}
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div
                                style={{
                                    textAlign: tableColumn?.align || "center",
                                    justifyContent: tableColumn?.align || "center",
                                    width: tableColumn?.width
                                        ? tableColumn?.width
                                        : "100%",
                                    whiteSpace: tableColumn?.width ? 'break-spaces' : "inherit",
                                    wordBreak: tableColumn?.width ? 'break-all' : "inherit",

                                }}
                            >
                                {text}
                            </div>
                        );
                    }
                },
                // enableHiding:true,
            };
        });
        if (rowSelectType === "radio") {
            transferColumns.unshift({
                id: "radio_select",
                accessorKey: rowKey,
                disabled: true,
                size: 15,
                enableSorting: false,

                header: ({ table }) => {
                    return <></>;
                },
                cell: ({ row }) => {
                    let text = row?.original;
                    if (rowKey) {
                        text = text[rowKey];
                    }
                    let record = row?.original;
                    let selectedRowKey = selectedRowKeys.find((e) => true);

                    return (
                        <div
                            style={{
                                textAlign: "center",
                                justifyContent: 'center',
                            }}
                        >
                            <RadioGroup
                                value={selectedRowKey}
                                onValueChange={() => {
                                    setSelectedRowKeys([text]);
                                    setSelectedRowsInfo([record]);
                                }}
                            >
                                <RadioGroupItem value={text} />
                            </RadioGroup>
                        </div>
                    );
                },
                enableHiding: false,
            });
        }
        else if (rowSelectType === "checkbox") {
            transferColumns.unshift({
                id: "checkbox_select",
                accessorKey: rowKey,
                disabled: true,
                enableSorting: false,
                enableHiding: false,
                size: 15,
                maxSize: 15,
                header: ({ table }) => {
                    let checked = currentTableData.every((value) => {
                        return selectedRowKeys.includes(value[rowKey]);
                    });
                    let currentTableKeys = currentTableData.map((value) => {
                        return value[rowKey];
                    });
                    let changeRows = [];
                    let selectedRows = [];
                    return (
                        <div
                            style={{
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Checkbox
                                checked={checked}
                                onCheckedChange={(value) => {
                                    let select_temp = [...selectedRowKeys];
                                    let select_temp_info = [...selectedRowsInfo];
                                    if (value) {
                                        currentTableData.forEach((element) => {
                                            if (
                                                !selectedRowKeys.includes(
                                                    element[rowKey]
                                                )
                                            ) {
                                                select_temp.push(
                                                    element[rowKey]
                                                );
                                                select_temp_info.push(
                                                    element
                                                );
                                                changeRows.push(element);
                                            }
                                        });
                                    } else {
                                        select_temp = select_temp.filter(
                                            (element) => {
                                                return !currentTableKeys.includes(
                                                    element
                                                );
                                            }
                                        );
                                        select_temp_info = select_temp_info.filter(
                                            (element) => {
                                                return !currentTableKeys.includes(
                                                    element[rowKey]
                                                );
                                            }
                                        );
                                        changeRows = [...currentTableData];
                                    }
                                    selectedRows = select_temp.map(
                                        (rowkeyValue) => {
                                            return currentTableData.find(
                                                (ele) => {
                                                    return (
                                                        ele[rowKey] ===
                                                        rowkeyValue
                                                    );
                                                }
                                            );
                                        }
                                    );
                                    onSelectAll(
                                        value,
                                        selectedRows,
                                        changeRows
                                    );
                                    setSelectedRowKeys(select_temp);
                                    setSelectedRowsInfo(select_temp_info);
                                }}
                                aria-label="Select all"
                            />
                        </div>
                    );
                },
                cell: ({ row }) => {
                    let text = row?.original;
                    if (rowKey) {
                        text = text[rowKey];
                    }
                    let selectedRows = [];
                    let record = row?.original;
                    return (
                        <div
                            style={{
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Checkbox
                                checked={selectedRowKeys.includes(text)}
                                onCheckedChange={(value) => {
                                    let select_temp = [...selectedRowKeys];
                                    let select_temp_info = [...selectedRowsInfo];
                                    if (value) {
                                        select_temp.push(text);
                                        select_temp_info.push(record);
                                    } else {
                                        select_temp = select_temp.filter(
                                            (element) => {
                                                return element !== text;
                                            }
                                        );
                                        select_temp_info = select_temp_info.filter(
                                            (element) => {
                                                return element[rowKey] !== record[rowKey];
                                            }
                                        );
                                    }
                                    selectedRows = select_temp.map(
                                        (rowkeyValue) => {
                                            return currentTableData.find(
                                                (ele) => {
                                                    return (
                                                        ele[rowKey] ===
                                                        rowkeyValue
                                                    );
                                                }
                                            );
                                        }
                                    );
                                    onSelect(record, value, selectedRows);
                                    setSelectedRowKeys(select_temp);
                                    setSelectedRowsInfo(select_temp_info);
                                }}
                                aria-label="Select row"
                            />
                        </div>
                    );
                },
            });
        }
        if (extraActionRenderShow && (propsPatch || propsDelete || propsPostChildren || !isArrowFunctionEmptyBlock(extraActionRender))) {
            transferColumns.push({
                id: "action",
                accessorKey: rowKey,
                disabled: true,
                enableSorting: false,
                enableHiding: false,
                minSize: 200,  // 設定這個即可，避免欄位太小
                header: ({ table }) => {
                    return (
                        <div
                            style={{
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Action />
                        </div>
                    );
                },
                cell: ({ row }) => {
                    let selectedRows = [];
                    let record = row?.original;
                    return (
                        <Row style={{ minWidth: 200 }}>
                            <Col span={24}>
                                <Row justify="center" gutter={[4, 4]}  >
                                    <Col>
                                        {
                                            !readonly && propsPostChildren && <PostButton
                                                childrenText={propsChildrenText}
                                                onClick={() => {
                                                    propsPostOnBefore(record)
                                                    setModalOpen(true);
                                                    setAxiosMode("post")
                                                    // propsForm.resetFields()
                                                    propsForm.resetFields({
                                                        'recordset': [{
                                                            ...(propsPostChildrenKey?.reduce((pre, [key, value]) => (
                                                                {
                                                                    ...pre,
                                                                    [key]: record?.value
                                                                }
                                                            ), {})),
                                                            ...initialValues,
                                                            classify_structure_type_id: record?.classify_structure_type_id || 0,
                                                            classify_structure_type_parent_id: record?.classify_structure_type_id || 0,
                                                        }]
                                                    })
                                                }}
                                            />
                                        }
                                    </Col>
                                    <Col>
                                        {!readonly && propsPatch && <PatchButton
                                            hidden={(record?.can_edit !== undefined && !record?.can_edit) || false}
                                            onClick={() => {
                                                setModalOpen(true);
                                                setAxiosMode("patch")
                                                // propsForm.resetFields();
                                                let formValues = [record]
                                                if (propsPatchProcess) {
                                                    formValues = formValues?.map(item => propsPatchProcess(item))
                                                }
                                                // setTimeout(() => {
                                                //     propsForm.setFieldsValue({ 'recordset': formValues })
                                                // }, 100);
                                                propsForm.resetFields({ 'recordset': formValues })
                                            }} />}
                                    </Col>
                                    <Col>
                                        {!readonly && propsDelete && <DeleteButton
                                            hidden={(record?.can_edit !== undefined && !record?.can_edit) || false}
                                            propsDeleteModal={propsDeleteModal}
                                            onConfirm={() => {
                                                const { deleteData } = (propsUseData && propsUseData({})) || { deleteData: () => { } };
                                                deleteData([record])
                                            }}
                                            isSent={!!record.is_sent}
                                        />}
                                    </Col>
                                    <Col>
                                        {extraActionRender(record)}
                                    </Col>
                                </Row>
                            </Col>
                        </Row >
                    );
                },
            })
        }
        return transferColumns;
    };
    const transferSortAntdToShadcn = ({ sorts }) => {
        let transferSort = {};
        sorts.forEach((sort) => {
            let sorter = !!sort?.desc ? "descend" : "ascend";
            transferSort[sort?.id] = sorter;
        });

        return transferSort || {};
    };

    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    };
};
export { useProTableOt };

const Action = ({ }) => {
    const { t } = useTranslation('translation')
    return <>
        {t('action')}
    </>
}
const PostButton = ({ ischildren = true, onClick = () => { }, childrenText, ...props }) => {
    const { t } = useTranslation('translation')
    return <>
        <Button
            style={{
                backgroundColor: '#C8E6C9',
                color: '#388E3C'
            }}
            onClick={onClick}
            {...props}
        >
            {t('post')}{ischildren && (childrenText ?? t('children'))}
        </Button>
    </>
}
export { PostButton }

const PatchButton = ({
    onClick = () => { },
    hidden = false,
    isSent = false, // 新增 isSent 屬性,
    ...props
}) => {
    const { t } = useTranslation('translation')
    return <>
        <Button
            disabled={isSent}
            onClick={onClick}
            style={{
                ...(hidden ? { display: 'none' } : {}),
                backgroundColor: '#BBDEFB',
                color: '#1976D2'
            }}
            {...props}
        >
            {t('patch')}
        </Button>
    </>
}
export { PatchButton }

const ModifyModal = ({
    title,
    axiosMode = "patch",
    propsForm,
    PropsPatchForm = () => <></>,
    propsOnModalConfirm,
    propsUseData = () => { },
    modalOpen = false,
    setModalOpen = () => { },
    propsWidth,
    initialValues,
    propsDefaultAxiosMode,
    formMode = false,/* dev */
    isMultipleEdit = true,
    prefixRender,
    formSplit = [],
    formSplitDefaultText,
    propsPostTop = false,
}) => {
    const [form_] = Form.useForm()
    const form = propsForm ?? form_
    const [formChildren] = Form.useForm()
    const [modalLoading, setModalLoading] = useState(false)

    const onFormFinish = async () => {
        const values = form.getFieldsValue();
        const { recordset } = values
        setModalLoading(true)
        if (axiosMode === "patch") {
            await patchData(recordset)
        } else if (axiosMode === "post") {
            await postData(recordset)
        }
        setModalLoading(false)
    }
    // 這樣寫會出事
    // const { patchData } = propsUseData({})
    const { patchData, postData } = (propsUseData && propsUseData({})) || { patchData: () => { }, postData: () => { } };
    const recordset = Form.useWatch('recordset', propsForm)
    // useEffect(() => {
    //     console.log({
    //         recordset
    //     })
    //     formChildren.setFieldsValue(
    //         { [`form_data`]: recordset }
    //     )
    //     form.setFieldsValue(
    //         { [`form_data`]: recordset }
    //     )
    // }, [recordset])
    return <>
        <Form
            form={form}
            onFinish={onFormFinish}
        ></Form>
        <MainModal
            title={title}
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            {...(propsWidth ? { width: propsWidth } : {})}
            propsForm={form}

            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}

            onFinish={onFormFinish}
            contentStyle={(propsPostTop ? {
                maxHeight: 'auto',
                overflowX: 'auto',
                overflowY: 'auto',
            } : {})}

            formElement={<CustomForm
                initialValues={initialValues}
                PropsPatchForm={PropsPatchForm}
                recordset={recordset}
                axiosMode={axiosMode}
                propsDefaultAxiosMode={propsDefaultAxiosMode}
                formMode={formMode}
                isMultipleEdit={isMultipleEdit}
                prefixRender={prefixRender}
                formSplit={formSplit}
                formSplitDefaultText={formSplitDefaultText}
                propsPostTop={propsPostTop}
            />}
        />
    </>
}
export { ModifyModal, DeleteButton };
const DeleteButton = ({
    onConfirm = () => { },
    multiple = false,
    isSent = false, // 新增 isSent 屬性
    propsDeleteModal = false,
    hidden = false,
    children,
    ...props
}) => {
    const { t } = useTranslation('translation')
    const CustomPopconfirm = propsDeleteModal ? DeletePopHover : Popconfirm
    return <>
        <CustomPopconfirm
            description={t('confirm_delete_item')}
            onConfirm={onConfirm}
            disabled={isSent} // 根據 isSent 狀態決定 Popconfirm 是否啟用
        >
            <Button
                disabled={isSent}
                style={{
                    ...(hidden ? { display: 'none' } : {}),
                    backgroundColor: '#FFCDD2',
                    color: '#D32F2F'
                }}
                {...props}
            >
                {
                    children ? children :  multiple ? `${t('multiple')}${t('delete')}` : t('delete')
                }
                
            </Button>
        </CustomPopconfirm>
    </>
}


const CustomForm = ({
    axiosMode,
    propsForm,
    PropsPatchForm,
    propsOnModalConfirm,
    recordset,
    onFormFinish,
    initialValues = {},
    propsDefaultAxiosMode,
    formMode = false,
    isMultipleEdit = true,
    prefixRender = () => <></>,
    formSplit = [],
    formSplitDefaultText = '',
    propsPostTop = false
}) => {
    const { t } = useTranslation('translation')
    const [form_] = Form.useForm();
    const [loading, setLoading] = useState(formSplit.length !== 0)
    const form = propsForm ?? form_
    const onFinish = (values) => {
        if (propsOnModalConfirm) {
            propsOnModalConfirm({
                values,
                onFormFinish
            })
        } else {
            onFormFinish(values)
        }
    }
    const [count, setCount] = useState(0)

    const formValues = Form.useWatch('recordset', form)

    useEffect(() => {
        if (formSplit.length !== 0) {
            if (formValues !== undefined) {
                setTimeout(() => {
                    setLoading(false)
                }, 2000)
            }
        }
    }, [formValues])
    return <>
        {prefixRender()}
        <Form
            form={form}
            onFinish={onFinish}
        >
            {loading && <Spin />}
            {!loading && <Form.List
                name={'recordset'}
            >
                {(fields, { add, remove }) => <>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            {propsDefaultAxiosMode === undefined && axiosMode === "post" && isMultipleEdit &&
                                <Button

                                    onClick={() => add({ ...initialValues })}>{t("post")}
                                </Button>}
                        </Col>
                        <Col span={24} style={propsPostTop ? { maxHeight: '70vh', overflow: 'scroll' } : {}}>
                            <Row>
                                {[...formSplit, { title: formSplitDefaultText }]?.map(formSplitItem => <>
                                    <Col span={24 / (formSplit.length + 1)}>
                                        {formSplitItem?.title && <Typography.Title level={4}>{formSplitItem?.title}</Typography.Title>}
                                        <Row>
                                            {fields.map((field, fieldIndex) => {
                                                let flag = false
                                                if (formSplitItem?.label === undefined) {
                                                    formSplit?.map(formSplitItem_ => {
                                                        if (formSplitItem_?.label !== undefined) {
                                                            if (formValues?.[fieldIndex]?.[formSplitItem_?.label].includes(formSplitItem_?.value)) {
                                                                flag = true
                                                            }
                                                        }
                                                    })
                                                } else {
                                                    flag = true
                                                    if (formValues?.[fieldIndex]?.[formSplitItem?.label].includes(formSplitItem?.value)) {
                                                        flag = false
                                                    }
                                                }
                                                if (flag) {
                                                    return <></>
                                                }
                                                return <>
                                                    <Col span={24}>
                                                        <Card key={field.id}>
                                                            {propsDefaultAxiosMode === undefined && axiosMode === "post" && isMultipleEdit &&
                                                                <Button onClick={() => {
                                                                    remove(fieldIndex)
                                                                }}
                                                                >
                                                                    {t("delete")}</Button>}
                                                            {!formMode && <>
                                                                {React.cloneElement(PropsPatchForm, {
                                                                    count: count,
                                                                    key: field.id,
                                                                    ...(recordset !== undefined ?
                                                                        {
                                                                            defaultValue: recordset[fieldIndex]
                                                                        }
                                                                        : {}),
                                                                    propsOnValuesChange: (values) => {
                                                                        const formValues = form.getFieldValue(`recordset.${fieldIndex}`)
                                                                        form.setFieldsValue(
                                                                            {
                                                                                [`recordset.${fieldIndex}`]: {
                                                                                    ...formValues,
                                                                                    ...values
                                                                                }
                                                                            }
                                                                        )
                                                                        setCount(pre => pre + 1)
                                                                    }
                                                                })}
                                                            </>}
                                                            {formMode && <>
                                                                {React.cloneElement(PropsPatchForm, {
                                                                    key: field.id,
                                                                    propsForm: form,
                                                                    field: field,
                                                                    onFormFinish: onFormFinish,
                                                                })}
                                                            </>}
                                                        </Card>
                                                    </Col>
                                                </>
                                            })}
                                        </Row>
                                    </Col>
                                </>)}
                            </Row>
                        </Col>
                    </Row>
                </>}
            </Form.List>}
        </Form>
    </>
}
